import React from 'react';
import { createIcon } from './create-icon';
import './icon-add.scss';

export const IconAdd = createIcon(<div className="icon-add" />);
export const IconAddBlue = createIcon(<div className="icon-add-blue" />);
export const IconAddDisabled = createIcon(<div className="icon-add filter-disabled" />);
